/* eslint-disable sort-keys */
export const sizes = {
  borderRadius: "0.5rem",
  borderRadiusRounded: "10000px",
  borderRadiusButton: ".5rem",

  menuHeight: "8rem",

  contentMaxWidth: "140rem",

  pagePadding: {
    landscape: "7rem",
    portrait: "3rem",
    mobile: "2rem",
  },

  cardMargin: "3rem",
  cardMarginSmall: "1.5rem",

  landscapeWidth: 1350,
  portraitWidth: 824,
  mobileWidth: 480,
}
